import React, { Component } from 'react';
import {getColumnCheck} from "./Client_Currency.js";
import "./Cell.css"

function fillRate(curr, rateConversion, rate_list) {
    var rate_dict = rate_list;
    var mapping = {USD:0,
                    CAD:1,
                    EUR:2,
                    GBP:3};
    try{
      if (Object.keys(rate_dict).includes(curr)) {
        var rates = rate_dict[curr].split(',');

        if (rates[mapping[rateConversion]] === "None") {
          return "Enter rate in " + rateConversion
        }
        return rates[mapping[rateConversion]]
      }else{
        return "Enter rate in " + rateConversion
      }
    }
    catch(error) {
      console.error(error);
      return "Loading...";
      // expected output: SyntaxError: unterminated string literal
      // Note - error messages will vary depending on browser
    }
}


class Cell extends Component {
  render() {
    var from, to, id, rate_list, client_id,className,val,style,config, visible = false;
    from = this.props.from;
    to = this.props.to;
    rate_list = this.props.rate_list;
    client_id = this.props.client_id;
    config = this.props.config;
    
    id = from + "2" + to
    val = fillRate(from, to, rate_list);
    if (isNaN(val)){
      className = 'no-rate';
    }else {
      className = 'filled-rate';
    }

    if(getColumnCheck(client_id, to, config) && rate_list[from]) visible = true;
    return (
      visible && (
        <input type="text" id={id} className={className} style={style}
          placeholder={val} onChange={this.props.onChange} />
      )
    );
  }
};

export default Cell;